module.exports = __webpack_public_path__ + "img/vip-badge.d48a717c.png";